<template>
  <div>
    <user-detail-title
      first-bread="供应商"
      second-bread="供应商修改"
      first-url="/user/supply"
      title-name="供应商修改"
    ></user-detail-title>
    <user-detail-base
      style="height: 81vh;"
    >
      <el-form label-position="left" label-width="100px">
        <el-form-item label="公司名称">
          <el-input v-model="Clist.companyName"></el-input>
        </el-form-item>
        <el-form-item label="logo图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker v-model="Clist.colour" show-alpha></el-color-picker>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "SupplyChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        Clist: {
          'id':this.$route.params.id,
          'companyName':null,
          'logoUrl':null,
          'colour':null,
        },//表示Add添加的数据
      }
    },
    methods:{
      GetUrlList(file){
        this.Clist.logoUrl=file.data;
      },
      handleChange(){
        if ( this.Clist.colour || this.Clist.companyName || this.Clist.logoUrl){
          this.$axios.post('/api/supplier/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.Clist= {
                'id':this.$route.params.id,
                'companyName':null,
                'logoUrl':null,
                'colour':null,
              }//表示Add添加的数据,
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一项上传')
        }

      }
    },
  }
</script>

<style scoped>

</style>